"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_update_1 = require("../../../topic-update/topic-update");
var add_topic_result_1 = require("./add-topic-result");
/**
 * Server response code when adding a topic
 */
var AddTopicResultCode;
(function (AddTopicResultCode) {
    AddTopicResultCode[AddTopicResultCode["CREATED"] = 0] = "CREATED";
    AddTopicResultCode[AddTopicResultCode["EXISTS"] = 1] = "EXISTS";
})(AddTopicResultCode || (AddTopicResultCode = {}));
/**
 * Serialiser for {@link AddTopicResult}
 */
var AddTopicResultSerialiserClass = /** @class */ (function (_super) {
    __extends(AddTopicResultSerialiserClass, _super);
    function AddTopicResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link AddTopicResult} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link AddTopicResult} that was read
     */
    AddTopicResultSerialiserClass.prototype.read = function (bis) {
        var addTopicResult = BEES.read(bis, AddTopicResultCode);
        var result = (addTopicResult === AddTopicResultCode.CREATED)
            ? topic_update_1.TopicCreationResult.CREATED
            : topic_update_1.TopicCreationResult.EXISTS;
        return new add_topic_result_1.AddTopicResult(result);
    };
    return AddTopicResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.AddTopicResultSerialiserClass = AddTopicResultSerialiserClass;
/**
 * The {@link AddTopicResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.AddTopicResultSerialiser = new AddTopicResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/add-topic-result-serialiser.js
// module id = 850
// module chunks = 1